import { Anchor, Box, Button, Flex, Modal, Text, Tooltip } from "@mantine/core";
import { IconCircleCheck, IconX, IconCheck} from "@tabler/icons";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { showNotification } from "@mantine/notifications";
import { openModal } from "@mantine/modals";
import LogoIcon from "../../../../layouts/LogoIcon";
import AiCommentsMenu from "../Comment/AiCommentsMenu";
import { assignRequestToNewIdea } from "../../../../../Api";
import { DeclineModal } from "../actions/DeclineModal";
import { RequestAssignment } from "../actions/RequestAssignment";
import AssignActionsMenu from "../actions/AssignActionsMenu";
import { useIdeaPage } from "../../../../../hooks/ideaPage";
import {useKnowledgeData} from "../../../../../hooks/useKnowledgeData";
import {useFields} from "../../../../../hooks/useFields";
import {useUserPermissions} from "../../../../../hooks/useUserPermissions";
import { useEvidenceActions } from "../../../../evidences/store/useEvidenceActions";
const AiValidatedRequestActions = ({ navToPerspective,chosenEvidence, validation, hoverCard, setShowHoverCard }: { navToPerspective: any; chosenEvidence: any, validation?: boolean, hoverCard?: boolean, setShowHoverCard?: (show: boolean) => void; }) => {

  const { 
    refetchEvidences, 
    idea,

  } = useIdeaPage();

  
  const { allComponents } = useFields();
  const { defaultStatus , defaultPriority } = useKnowledgeData();
  const auth0 = useAuth0();
  const [opened, setOpened] = useState(false);
  const { canManageEvidence } = useUserPermissions();
  const { unassign, isLoading: evidenceActionsLoading } = useEvidenceActions();

  const handleUnassign = async () => {
    try {
      await unassign(chosenEvidence._id, idea._id);
      refetchEvidences();
      setShowHoverCard?.(false);
      navToPerspective();
    } catch (e) {
      console.error(e);
    }
  };

  const createNew = () => {
    const newIdeaObj = {
      title: chosenEvidence?.title,
      description: chosenEvidence?.text,
      componentId: chosenEvidence?.componentId,
      ownerId: null,
      rolloutDate: null,
      status: defaultStatus,
      priority: defaultPriority,
    };

    const _body = {
      idea: newIdeaObj,
      evidence: { ...chosenEvidence },
    };

    if (!chosenEvidence?.componentId) {
      showNotification({
        title: "Product Area Missing",
        color: "red",
        message: "Please assign a product area to this request before creating a new idea.",
        icon: <IconX size="1.1rem" />,
        autoClose: 1200,
      });
      return;
    }
    if (chosenEvidence?.componentId) {
      const foundComponent = allComponents.find((c: any)=> c._id === chosenEvidence?.componentId)
      if(!foundComponent){
        showNotification({
          title: "Invalid Product Area",
          color: "red",
          message: "Please assign a product area to this request before creating a new idea.",
          icon: <IconX size="1.1rem" />,
          autoClose: 1200,
        });
        return;
      }
  
      _body.idea.ownerId = foundComponent.ownerId;
      _body.evidence.ownerId = foundComponent.ownerId;
  
      // Submit the new idea request
      assignRequestToNewIdea(_body, auth0)
        .then((response) => {
          const ideaId = response.createNewIdeaRes?.idea?._id;
          showNotification({
            title: "Assigned successfully!",
            color: "teal",
            message: <Box>
              <Text>New idea has been created</Text>
              <Anchor href={`/idea/${ideaId}`} target="_blank">
                Go to the new idea
              </Anchor>
            </Box>,
            icon: <IconCheck size="1.1rem" />,
            autoClose: 1200
          });
          if (ideaId) {
            refetchEvidences()
            setTimeout(() => {
              window.open(`/idea/${ideaId}`);
            }, 1300);
          } else {
            console.log(`did not receive request id for new idea`, response);
          }
        })
        .catch(console.log)
    }
  };

  const openDeclineModal = () => {
    setOpened && setOpened(false);
    openModal({
      modalId: "decline",
      title: <LogoIcon />,
      centered: true,
      size: 600,
      children: (
        <DeclineModal
          request={chosenEvidence}
          idea={idea}
          navToPerspective={navToPerspective}
          loadEvidence={refetchEvidences}

        />
      ),
    });
  };

  if (!canManageEvidence) {
    return (
      <Flex align="center" justify="center" p="sm">
        <Text color="dimmed" size="xs">
          View only - contact Admin or Manager to take action
        </Text>
      </Flex>
    );
  }
  
  return (
    <Flex
      justify={hoverCard ? "flex-start" : "space-between"}
      px={hoverCard ? 0 : "35px"}
      w={hoverCard ? "auto" : "100%"}
      pb={hoverCard ? "-50px" : "20px"}
      h={ hoverCard ? "auto" : "64px"}
      sx={{ /* borderTop: "1px solid #D8D8DB", */ borderBottom: hoverCard ? "none" : "1px solid #D8D8DB" }}
      align="center"
    >
      {opened && <Modal
        centered
        opened={opened}
        onClose={() => setOpened(false)}
        size="34vw"
        title={
          <Text fz={20} fw={600}>
            Reassign to another idea
          </Text>
        }
      >
        <Box h={440}>
          <RequestAssignment
            idea={idea}
            item={chosenEvidence}
            setOpened={setOpened}
            navToPerspective={navToPerspective}
            TextInputW="100%"
            BoxW="38vw"
            isIdeaAi={true}
            ideaId={idea._id}
          />
        </Box>
      </Modal>}
      {!validation && !hoverCard && <AiCommentsMenu chosenEvidence={chosenEvidence}/>}
      <Flex align="center">
        <Button.Group>
          <Tooltip
            label="Re-assign to another Idea"
            multiline
            maw={200}
            offset={12}
            position="left"
          >
            <Button
              fz="12px"
              color="indigo"
              w="180px"
              loading={evidenceActionsLoading.unassign}
              styles={(theme) => ({
                root: {
                  height: "32px",
                  backgroundColor: "#5C5CEB",
                  color: "white",
                  border: 0,
                  fontWeight: 400,
                  padding: "0px 5px",
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  "&:hover": {
                    backgroundColor:  theme.fn.darken("#5353D3", 0.05),
                  },
                },

                loader: {
                  position: "absolute",
                  color: theme.white,
                },

                leftIcon: {
                  marginRight: 15,
                },
              })}
              onClick={() => {
                setOpened(true);
              }}
            >
              {!evidenceActionsLoading.unassign && (
                <>
                  {!hoverCard ? (<IconCircleCheck size={16} fill="white" color="#5C5CEB"/>) : null}
                  <Text ml={5} fw={500}>Re-assign to another idea</Text>
                </>
              )}
            </Button>
          </Tooltip>
          <AssignActionsMenu
            actions={[
              ...(chosenEvidence?.ideaId ? [{
                label: evidenceActionsLoading.unassign ? "Unassigning..." : "Unassign",
                tooltip: "Unassign",
                onClick: handleUnassign,
              }] : []),
              {
                label: "Decline",
                tooltip: "Decline",
                onClick: () => {
                  setShowHoverCard?.(false);
                  openDeclineModal();
                }
              },
              {
                label: "Re-assign to a new idea",
                tooltip: "Re-assign to a new idea",
                onClick: () => {
                  createNew();
                  setShowHoverCard?.(false);
                }
              },
            ]}
          />
        </Button.Group>
      </Flex>
    </Flex>
  );
};

export default AiValidatedRequestActions;